import { render, staticRenderFns } from "./CrystalPalace.vue?vue&type=template&id=53478c93&"
import script from "./CrystalPalace.vue?vue&type=script&lang=js&"
export * from "./CrystalPalace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports